import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { Box as DarkBox } from '@hivewatch/dark'

import { FloorsFacilityCheckpointsQuery } from '@/graphql/generated/operations'

import { DarkCheckpointSelectRow } from './DarkCheckpointSelectRow'
import {
  emptyTextStyles,
  floorGroupHeaderStyles,
} from './DarkTourPlansPanel.styles'

interface DarkFloorCheckpointGroupsIProps {
  floorData: FloorsFacilityCheckpointsQuery
  currentFloorId: string
  checkedIds?: string[]
  onChecked: (deviceId: string) => void
}

// Checkpoints grouped by floor. Floor group headers render even when the
// group has no checkpoints, and the currently-viewed floor is labelled
// "Current Floor" (ENG-32001).
export const DarkFloorCheckpointGroups = ({
  floorData,
  currentFloorId,
  checkedIds,
  onChecked,
}: DarkFloorCheckpointGroupsIProps) => {
  const colorScheme = useLightMode()
  const { t } = useTranslation()

  if (!(floorData?.floors?.edges?.length > 0)) {
    return (
      <DarkBox {...emptyTextStyles(colorScheme)}>
        {t('common:list_empty')}
      </DarkBox>
    )
  }

  return (
    <DarkBox w='full'>
      {floorData.floors.edges.map((floor) => (
        <DarkBox display='flex' flexDirection='column' key={floor.node?.id}>
          <DarkBox {...floorGroupHeaderStyles(colorScheme)}>
            {floor?.node?.id === currentFloorId
              ? t('floors:plan_create_tour_current_floor')
              : floor?.node?.name}
          </DarkBox>
          {floor?.node?.devices?.edges.map((device) => (
            <DarkCheckpointSelectRow
              key={device.node?.id}
              label={device.node?.name}
              onChecked={() => onChecked(device.node?.id)}
              selected={checkedIds?.includes(device.node?.id)}
              subLabel={device.node?.checkpoint?.displayId}
            />
          ))}
        </DarkBox>
      ))}
    </DarkBox>
  )
}
